module.exports = __webpack_public_path__ + "static/img/view7-2.ca642f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view7-2.png
// module id = kMx1
// module chunks = 1